import React from 'react';

interface MarqueeProps {
  children: React.ReactNode;
}

const Marquee: React.FC<MarqueeProps> = ({ children }) => {
  const childrenArray = React.Children.toArray(children);
  // Seamless loop ke liye data duplicate kiya
  const duplicatedChildren = [...childrenArray, ...childrenArray];

  return (
    /* lg:h-[400px] desktop ke liye, mobile par cards ki height ke according auto rahega */
    <div className="relative overflow-hidden w-full h-[220px] lg:h-[360px]">
      {/* Mobile: flex (horizontal layout), animate-marquee-horizontal
          Desktop: lg:block (vertical layout), lg:animate-marquee-vertical
      */}
      <div className="flex lg:block absolute top-0 left-0 h-full lg:h-auto animate-marquee-horizontal lg:animate-marquee-vertical whitespace-nowrap lg:whitespace-normal">
        {duplicatedChildren.map((child, index) => (
          <div key={index} className="inline-block lg:block h-full lg:h-auto mr-4 lg:mr-0 lg:mb-4">
            {child}
          </div>
        ))}
      </div>
    </div>
  );
};

export default Marquee;